<div
  class="label-value-list"
  [class.label-value-list--in-expansion-panel]="inExpansionPanel()"
>
  <ng-content />
</div>
